import classNames from 'classnames'
import { ru } from 'date-fns/locale/ru'
import type { Moment } from 'moment'
import moment from 'moment'
import { forwardRef } from 'react'
import DatePicker, { registerLocale } from 'react-datepicker'

import 'react-datepicker/dist/react-datepicker.css'

import { EIcons } from '@/app/types/iconType'
import { Icon } from '@/shared'

import { CustomYearDropdown } from './CustomYearDropdown/CustomYearDropdown'
import style from './Datepicker.module.scss'

import './calendar.css'

registerLocale('ru', ru)

interface IProps {
    value: Moment | null
    onChange: (e: Moment) => void
    onSetIsTouched?: () => void
    disabled?: boolean
    error?: string | null
    isTouched?: boolean
}

export const DatepickerComponent = (props: IProps) => {
    const { value, isTouched, onChange, onSetIsTouched, disabled, error } = props
    const isError = isTouched && error
    return (
        <DatePicker
            wrapperClassName={classNames(style.wrapperClassName, isError && style.wrapperClassNameError)}
            selected={value ? new Date(moment(value).format('YYYY-MM-DD')) : null}
            locale='ru'
            showYearDropdown={true}
            dateFormat='dd.MM.yyyy'
            onInputClick={onSetIsTouched}
            renderCustomHeader={CustomYearDropdown}
            onChange={(date: Date | null) => {
                const SD = date ? moment(date).format('YYYY-MM-DD') : null
                onChange(moment(SD))
            }}
            customInput={<CustomDate />}
            disabled={disabled}
            // isClearable={true}
            // withPortal
        />
    )
}

const CustomDate = forwardRef(
    ({ disabled, value, onClick }: { disabled?: boolean; value?: string; onClick?: () => void }, ref) => (
        <div
            className={classNames(style.container, disabled && style.containerDisbled)}
            onClick={onClick}
            ref={ref as any}
            style={{ width: '100%' }}
        >
            {value || 'Дата отсутствует'}
            {!disabled && (
                <div className={style.trigger}>
                    <Icon iconName={EIcons.AROW} color='#1F3447' />
                </div>
            )}
        </div>
    )
)

CustomDate.displayName = 'CustomDate'
